import React from "react";
import { Link } from "react-router-dom";

class Footer extends React.Component {
  render() {
    return <footer id="footer" style={{ background: "#F6F6F6" }}></footer>;
  }
}

export default Footer;
